import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { showToast } from "~/components/__deprecated";

import { profileService } from "../services";

interface UserFormData {
  firstName: string;
  lastName: string;
  displayName: string;
}

interface UpdatePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export const userProfileKeys = {
  all: ["selfprofile"],
  item: (id: number | string | null) => [...userProfileKeys.all, id],
};

export const useGetUserProfile = () =>
  useQuery({
    queryKey: userProfileKeys.all,
    queryFn: () => profileService.get("/users/me/profile"),
    ...{ refetchOnWindowFocus: false },
  });

export const useUpdateUserNames = (onSuccessCallback?: () => void) => {
  const queryClient = useQueryClient();
  const auth = useAuth();

  return useMutation({
    mutationFn: (data: UserFormData) => profileService.put("/users/me/profile", data),
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: userProfileKeys.all });

      auth?.signinSilent?.().catch((err) => {
        console.error("Silent signin failed:", err);
      });

      onSuccessCallback?.();

      showToast("Your name has been successfully updated.", "success");
    },
    onError: () => {
      showToast("An error occurred while updating your name.", "error");
    },
  });
};

export const useUpdatePassword = () =>
  useMutation({
    mutationFn: (data: UpdatePasswordPayload) => profileService.put("/users/me/password", data),
  });

export const useMyMemberships = () =>
  useQuery({
    queryKey: userProfileKeys.item(null),
    queryFn: () => profileService.post("/memberships/me/_search"),
    refetchOnWindowFocus: false,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
